<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="0"
      absolute
      auto-height
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-layout class="mt-12">
      <v-flex xs12>
        <div :class="paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
          <v-card-text>
            <v-layout>
              <span class="accent--text"
                    style="font-size: 14px; font-weight:700;">  Approve Farmer Update Requests </span>
              <v-spacer>
              </v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search">
                </v-text-field>
              </v-flex>
            </v-layout>
            <table class="table">
              <thead class="thead">
              <tr>
                <th scope="col">First Name</th>
                <th scope="col">Middle Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">ID Number</th>
                <th scope="col">Mobile Number</th>
                <th scope="col">Member Number</th>
                <th scope="col">Gender</th>
                <th scope="col">Bank Code</th>
                <th scope="col">Account</th>
                <th scope="col">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="farmer in filteredList" v-bind:key="farmer.id">
                <td> {{ farmer.firstName }}</td>
                <td> {{ farmer.middleName }}</td>
                <td> {{ farmer.lastName }}</td>
                <td>{{ farmer.farmerId }}</td>
                <td> {{ farmer.mobileNumber }}</td>
                <td>{{ farmer.memberNumber }}</td>
                <td>{{ farmer.gender }}</td>
                <td>{{ farmer.bankCode }}</td>
                <td>{{ farmer.bankAccount }}</td>
                <td class="actions">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        v-on="on"
                        flat
                        icon
                        class="actions"
                      >
                        <v-icon class="secondary--text"> more_horiz</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title @click="showApproveDialog(farmer)">Approve</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title @click="showRejectDialog(farmer)">Reject</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog v-model="approveDialog" persistent width="500">
      <v-card>
        <v-card-title class="headline primary--text">Approve Record</v-card-title>
        <v-card-text>
          <v-flex xs8>
            <h5> Are you sure you want to approve the record? </h5>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="cancelDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="approveRecord">Approve</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rejectDialog" persistent>
      <v-card>
        <v-card-title class="headline primary--text">Reject Record</v-card-title>
        <v-card-text>
          <v-flex xs8>
            <v-text-field label="Rejection reason" v-model="farmer.approverComments"></v-text-field>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="cancelRejectDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="rejectRecord">Reject</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'

export default {
	name: 'viewfarmers',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			farmers: [],
			totalFarmers: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			farmerBankDetail: null,
			editDialog: false,
			farmer: { farmerBankDetail: { bank: {} } },
			approveDialog: false,
			rejectDialog: false,
			organisationType: '',
			organisationId: ''
		}
	},
	mounted () {
		this.getLoggedInUser()
		this.getFarmers()
	},
	watch: {
		farmers () {
			this.paginatedFiles = this.paginationMethod(this.farmers, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.farmers.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.farmers, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.farmers.filter(farmer => {
					return farmer.firstName.toLowerCase().includes(this.search.toLowerCase()) || (farmer.lastName === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : farmer.lastName.toLowerCase().includes(this.search.toLowerCase())) || farmer.farmerId.toLowerCase().includes(this.search.toLowerCase()) || farmer.mobileNumber.includes(this.search)
				})
			}
		}
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		getFarmers () {
			const url = config.serverURI + '/farmer/approve/pending_approval/' + this.organisationId
			axios.get(url)
				.then(response => {
					this.farmers = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		showApproveDialog (farmer) {
			this.approveDialog = true
			this.farmer = farmer
		},
		cancelDialog () {
			this.approveDialog = false
		},
		cancelRejectDialog () {
			this.rejectDialog = false
		},
		showRejectDialog (farmer) {
			this.rejectDialog = true
			this.farmer = farmer
		},
		approveRecord () {
			const url = config.serverURI + '/farmer/approve'
			axios.post(url, {
				id: this.farmer?.id,
				growerId: this.farmer?.organisation?.id,
				approverComments: this.farmer?.approverComments,
				companyName: this.farmer?.companyName,
				companyRegistrationNumber: this.farmer?.companyRegistrationNumber
			})
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.message)
						this.approveDialog = false
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.approveDialog = false
					this.getFarmers()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred while processing your request'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveDialog = false
				})
		},
		rejectRecord () {
			const url = config.serverURI + '/farmer/reject'
			axios.post(url, {
				id: this.farmer?.id,
				approverComments: this.farmer?.approverComments
			})
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.message)
						this.rejectDialog = false
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.rejectDialog = false
					this.getFarmers()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred while processing your request'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.rejectDialog = false
				})
		}
	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}
</style>
